import {
    RETURNGOODSLIST_SUCCESS,
    SETRETURNGOOD
} from "../actions/returnGoodsList";
import Vue from "vue";

const state = {
    returnGoodsList: []
};

const getters = {
    getReturnGoodsList: state => state.returnGoodsList,
    ifReturnGoodsListHasItems: state => !!state.status.length,
    returnGoodsListStatus: state => state.status
};

const mutations = {
    [RETURNGOODSLIST_SUCCESS]: (state, resp) => {
        state.status = "success";
        var list = resp.data.map(it => {
            var item = { ...it };
            item.Quantity = 0;
            return item;
        });
        Vue.set(state, "returnGoodsList", list);
    },
    [SETRETURNGOOD]: (state, data) => {
        var index = state.returnGoodsList.findIndex(f => f.ObjectId == data.objectId);
        state.returnGoodsList[index].Quantity = parseInt(data.value);
    }
};

export default {
    state,
    getters,
    mutations
};
